import ConsoleTable from '../../components/ConsoleTable.jsx';
import { fmt } from './people-format.jsx';

// The customer's tenant on the IPC Global sign-in does not exist yet (ENTRAID-307): no one was invited.
export const TENANT_MISSING_EMPTY = Object.freeze({ title: 'No one has been invited yet', body: 'Access requests appear here after the first person is invited to this customer.' });
// No verified domains are stored for this customer, so no request can be matched to it (PROD 2026-10-27).
export const DOMAINS_UNKNOWN_EMPTY = Object.freeze({ title: 'Verified domains not known yet', body: 'Access requests are matched to a customer by its verified Microsoft Entra domains, and none are on record for this customer yet. They are read when Watch is turned on or a sending domain is set up.' });
const DEFAULT_EMPTY = Object.freeze({ title: 'No access requests', body: 'People from this customer\'s verified domains who sign in without access to any customer appear here. IPC Global staff never appear here.' });

/**
 * Operators only: people of this customer's verified domains who signed in with no access to any customer
 * (ENTRAID-300). Staff requests are never listed for a customer.
 */
export default function AccessRequestsTab({ requests, tenantMissing = false, domainsUnknown = false, onPreAssign, onDismiss }) {
  const columns = [
    { id: 'email', header: 'Email', sortValue: (r) => r.email.toLowerCase(), cell: (r) => <span className="break-all">{r.email}</span> },
    { id: 'first', header: 'First seen', hideBelow: 'md', sortValue: (r) => Date.parse(r.firstSeenAt) || 0, cell: (r) => fmt(r.firstSeenAt) ?? '--' },
    { id: 'last', header: 'Last seen', sortValue: (r) => Date.parse(r.lastSeenAt) || 0, cell: (r) => fmt(r.lastSeenAt) ?? '--' },
    { id: 'count', header: 'Sign-ins', sortValue: (r) => r.signInCount ?? 0, align: 'right', cell: (r) => String(r.signInCount ?? 0) },
  ];
  return (
    <ConsoleTable
      label="Access requests"
      columns={columns}
      rows={requests}
      getRowId={(r) => r.email}
      rowName={(r) => r.email}
      searchText={(r) => r.email}
      searchPlaceholder="Search access requests"
      defaultSort={{ columnId: 'last', direction: 'descending' }}
      rowActions={(r) => [
        { id: 'pre', label: 'Pre-assign roles', onSelect: () => onPreAssign(r.email) },
        { id: 'dismiss', label: 'Dismiss', danger: true, onSelect: () => onDismiss(r.email) },
      ]}
      emptyState={domainsUnknown ? DOMAINS_UNKNOWN_EMPTY : tenantMissing ? TENANT_MISSING_EMPTY : DEFAULT_EMPTY}
    />
  );
}
